import { getIdOrNull } from '..'
import apiClient from './apiClient'

export const getAllLinkRequests = (user, params = {}) => apiClient.get(user, 'api/link-requests', params)

export const createLinkRequest = (user, body) => apiClient.post(user, 'api/link-requests', body)

export const approveLinkRequest = (user, linkRequest) => apiClient.patch(user, `api/link-requests/${getIdOrNull(linkRequest)}/approve`)

export const rejectLinkRequest = (user, linkRequest) => apiClient.patch(user, `api/link-requests/${getIdOrNull(linkRequest)}/reject`)
